import useUserInfo from './useUserInfo';

const useUserEmail = () => useUserInfo()?.email ?? '';

export default useUserEmail;
